import React from 'react';
import { SubscriptionStatus } from '../../../../models';
import { Alert, Box } from '@chargify/custom-ui-components';
import { useTranslation } from 'react-i18next';
import { MarginProps } from 'styled-system';
interface Props {
  status: SubscriptionStatus;
  show3DSModal: () => void;
  existingBalance: string;
}
const Notification = ({
  status,
  show3DSModal,
  existingBalance,
  ...rest
}: Props & MarginProps) => {
  const { t } = useTranslation('subscriptions-manager');

  const renderAlert = (status: SubscriptionStatus) => {
    switch (status) {
      case 'cancellation_scheduled':
        return (
          <Alert>
            <Alert.TextMessage>
              {t(
                'subscription_details.your_plan_has_been_scheduled_for_cancellation'
              )}
            </Alert.TextMessage>
          </Alert>
        );
      case 'past_due':
        return (
          <Alert
            color="danger"
            buttonLabel={t('threeDs.authorize_payment')}
            onClick={show3DSModal}
            title={t('threeDs.payment_auth_fail_title')}
          >
            <Alert.TextMessage>
              {t('threeDs.payment_auth_fail_description', {
                balance: existingBalance,
              })}
            </Alert.TextMessage>
          </Alert>
        );
      case 'unpaid':
        return (
          <Alert color="danger">
            <Alert.TextMessage>
              {t('subscription_details.your_recurring_payment_has_failed')}
            </Alert.TextMessage>
          </Alert>
        );
      case 'trial_expired':
        return (
          <Alert>
            <Alert.TextMessage>
              {t('subscription_details.your_trial_has_expired')}
            </Alert.TextMessage>
          </Alert>
        );
      case 'expired':
        return (
          <Alert>
            <Alert.TextMessage>
              {t('subscription_details.your_subscription_has_expired')}
            </Alert.TextMessage>
          </Alert>
        );
      default:
        return null;
    }
  };
  const alert = renderAlert(status);
  return alert ? <Box {...rest}>{alert}</Box> : null;
};
export default Notification;
